var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value),function(item,index){return _c(`section-${item.key}`,{key:index,tag:"component",staticClass:"content_section",attrs:{"id":`content-builder-item-${index}`,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }